'use client';
import { useEffect, useState } from 'react';
import Summary from './summary';
import { db } from '@/lib/db';
import { useDispatch } from 'react-redux';
import { setSummaryData } from '@/redux/slices/summary/summarySlice';
import { showSuccessToast, showErrorToast } from "@/components/toast/toast";

interface OfflineSummaryProps {
  projectId: string;
  isOffline?: boolean;
}

export default function OfflineSummary({ projectId, isOffline }: OfflineSummaryProps) {
  const [isLoading, setIsLoading] = useState(true);
  const dispatch = useDispatch();

  useEffect(() => {
    const loadSummaryData = async () => {
      if (projectId) {
        try {
          setIsLoading(true);
          const project = await db.getFullProject(projectId);
          
          if (project?.summaryData) {
            dispatch(setSummaryData(project.summaryData));
          }
        } catch (error) {
          console.error('Error loading summary data:', error);
          showErrorToast('Failed to load summary configuration');
        } finally {
          setIsLoading(false);
        }
      } else {
        setIsLoading(false);
      }
    };

    loadSummaryData();
  }, [projectId, dispatch]);

  const handleOfflineSubmit = async (values: any) => {
    try {
      const project = await db.getFullProject(projectId);
      if (project) {
        await db.projects.update(projectId, {
          ...project,
          summaryData: {
            ...values,
            updatedAt: new Date().toISOString()
          }
        });
        showSuccessToast("Summary data saved offline");
      }
    } catch (error) {
      console.error('Error saving summary data:', error);
      showErrorToast("Failed to save summary data");
    }
  };

  if (isLoading) {
    return <div>Loading summary configuration...</div>;
  }

  return (
    <Summary 
      projectId={projectId}
      isOffline={isOffline}
      onOfflineSubmit={handleOfflineSubmit}
    />
  );
} 